import React from 'react'
import ReadOnlyTask from '../ReadOnlyTask'
import {FormComponentPropTypes} from '../onboardingTypes'

function SmartLock(props) {
  return <ReadOnlyTask {...props} />
}

SmartLock.propTypes = FormComponentPropTypes

export default SmartLock
